import React, {useState, useEffect} from 'react';

import {useStaticQuery, graphql} from 'gatsby';
import {GridCard} from 'src/components/editorial';

import {Maybe, SanityEditorial} from 'types/generated';

interface RelatedArticleProps {
  relatedArticles: [Maybe<Pick<SanityEditorial, 'id' | 'title' | 'slug' | 'heroImage' | 'editorialCategory'>>];
}

export const MoreFromSeries: React.FC<RelatedArticleProps> = ({relatedArticles}: RelatedArticleProps) => {
  const Posts = relatedArticles.map(item => {
    return (
      <GridCard
        cardColClasses={
          'col-span-full md:col-span-4 grid grid-cols-2 gap-x-4 items-center md:items-start content-start'
        }
        title={item?.title}
        category={item?.editorialCategory?.title || ' '}
        image={item?.heroImage !== null ? item?.heroImage : null}
        imageClasses={'col-span-full pb-[68%] lg:h-[275px]'}
        contentClasses={'col-span-full mt-4 lg:mt-7'}
        titleClasses={'type-eta'}
        slug={item?.slug?.current ?? ''}
        key={item?.id}
        eyebrowClasses={'block type-eyebrow mb-2 text-green-dark'}
        editorialCategory={item?.editorialCategory}
      />
    );
  });
  return (
    <>
      <section className="px-gutter module-spacing pb-0" data-module="series-more">
        <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 md:gap-x-8 gap-y-7">
          <h2 className="type-beta lg:mb-11 col-span-full text-center capitalize">More From Series</h2>
          {Posts}
        </div>
      </section>
    </>
  );
};
